<app-header [widgets]="header?.widgets"></app-header>


<section class="container">

  <app-main-frame [widgets]="main?.widgets"></app-main-frame>

</section>

<div class="container">
  <!-- <h1 class="main-title py-2 neutral-1-color">In evidenza</h1> -->

</div>

<app-footer [widgets]="footer?.widgets"></app-footer>

<a href="#" aria-hidden="true" tabindex="-1" data-bs-toggle="backtotop" class="back-to-top back-to-top-small"
  style="position: fixed; bottom: 20px; right: 20px; background-color: rgba(0, 0, 0, 0.5); color: white; border-radius: 50%; padding: 10px; z-index: 1000;">
  <i class="bi bi-chevron-up" style="font-size: 24px;"></i>
</a>